import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * Custom RouteReuseStrategy that forces component recreation when :serviceId changes.
 *
 * Angular's DefaultRouteReuseStrategy reuses a component when future.routeConfig === curr.routeConfig,
 * even if route params (like :serviceId) have changed. This causes service page components to keep
 * stale route.snapshot.paramMap values and not re-render with the new service's data.
 */
export class ServiceAwareRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {}

  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.params['serviceId'] !== curr.params['serviceId']) {
      return false;
    }
    return future.routeConfig === curr.routeConfig;
  }
}
